<template>
	<div :style="{ width: width+'px', height: height+'px' }">
		<div
		v-if="settings.type=='table'"
		class="scroll"
		:style="{
			width: width+'px',
			height: height+'px',
			border:'1px solid '+settings.colors.frame,
			backgroundColor:settings.colors.background }">

			<table>
				<thead v-if="settings.fonts.title>0">
					<tr>
						<th v-for="data in values.column_names">
							<p :style="{ fontSize: settings.fonts.title*fontScale+'px' }">{{data}}</p>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="column in values.column_data">
						<td v-for="data in column">
							<p :style="{ fontSize: settings.fonts.value*fontScale+'px' }">{{data}}</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-else-if="settings.type=='image'" :style="{
			width: width+'px',
			height: height+'px',
			border:'1px solid '+settings.colors.frame,
			backgroundColor:settings.colors.background }">

			<canvas
			:id="id"
			:width="width"
			:height="height">
			</canvas>
		</div>
		<div v-else-if="settings.type=='download'" :style="{
			width: width+'px',
			height: height+'px',
			border:'1px solid '+settings.colors.frame,
			backgroundColor:settings.colors.background }">

			<p :style="{ fontSize: settings.fonts.title*fontScale+'px' }"><b>{{settings.title}}</b></p>
			<button v-on:click="download()"><font-awesome-icon icon="download" /></button>
		</div>
		<div v-else :style="{
			width: width+'px',
			height: height+'px',
			border: '1px solid '+settings.colors.frame,
			backgroundColor:settings.colors.background }">

			<button v-on:click="toggleLegend()"><font-awesome-icon icon="star" /></button>
			<canvas
			:id="id"
			:width="width"
			:height="height">
			</canvas>
			<canvas
			:id="id+'_legend'"
			:width="'200px'"
			:height="'200px'"
			class="legend">
			</canvas>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		id:String,
		values: Array,
		settings:Object,
		width:Number,
		height:Number,
    },
	data() {
		return {
			ctx:null,
			ctx_legend:null,
			font:"Arial",
			fontScale:1,
		}
	},
	mounted () {
		const dampingRatio = 0.5;
		this.fontScale = (((parseFloat(document.getElementById("graph").offsetWidth)-5)/2500)-1)*dampingRatio+1;
		this.setup()
	},
	methods:{
		setup(){
			var c = document.getElementById(this.id);
			var c_legend = document.getElementById(this.id+'_legend');
			if(c!=null && c_legend!=null){
				this.ctx = c.getContext("2d");
				this.ctx_legend = c_legend.getContext("2d");

				this.draw();
				this.loadToggleLegends();
			}

			if(c!=null && this.settings.type=='image'){
				this.ctx = c.getContext("2d");

				this.draw();
				this.loadToggleLegends();
			}
		},
		draw(){
			switch(this.settings.type){
				case "line":this.lineGraph();
				break;
				case "stacked":this.stackedGraph();
				break;
				case "pie":this.pieGraph();
				break;
				case "bar":this.barGraph();
				break;
				case "image":this.setImage();
				break;
				default:break;
			}
		},

		setImage(){
			api.getImage(
				{
					data:{
						filename:'pictures/'+this.values[0].label
					}
				}
			).then((res) => {
				var img = document.createElement('img')
				img.src="data:image/png;base64, "+res.data;

				let stateCheck = setInterval(() => {
					if (img.complete) {
						clearInterval(stateCheck);
						var scale = Math.min(this.width / img.width, this.height / img.height);
						var x = (this.width / 2) - (img.width / 2) * scale;
						var y = (this.height / 2) - (img.height / 2) * scale;
						this.ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
					}
				}, 100);
			});
		},
		download(){
			api.getFileDownload(
				{
					type:"search",
					data:{
						fileid:this.values[0].label,
						path:"download"
					}
				}
			).then((res) => {
				if(res.data!=null){
					var fileURL = window.URL.createObjectURL(new Blob([res.data]));
					var fileLink = document.createElement('a');

					var filename = this.values[0].label.split('/')[this.values[0].label.split('/').length-1];
					fileLink.href = fileURL;
					fileLink.setAttribute('download', filename);
					document.body.appendChild(fileLink);

					fileLink.click();
				}
			});
		},

		lineGraph(){
			var padding = [100,40,20,60]
			this.drawTable(padding,this.settings.title,this.settings.labelY,this.settings.labelX,this.settings.fonts,this.settings.colors);
			this.drawLine(padding,this.values,this.settings.fonts);
			this.drawScale(padding,
				{start:this.settings.minValueX,
					end:this.settings.maxValueX,
					intervals:this.settings.intervalsX,
					labeledIntervals:this.settings.labeledIntervalsX},
				{start:this.settings.minValueY,
					end:this.settings.maxValueY,
					intervals:this.settings.intervalsY,
					labeledIntervals:this.settings.labeledIntervalsY},
				this.settings.fonts,
				this.settings.labels);
			this.drawLegend(this.values,this.settings.fonts);
		},
		stackedGraph(){
			var padding = [100,40,20,60]
			this.drawTable(padding,this.settings.title,this.settings.labelY,this.settings.labelX,this.settings.fonts,this.settings.colors);
			this.drawStack(padding, this.values,this.settings.fonts);
			this.drawScale(padding,
				{start:this.settings.minValueX,
					end:this.settings.maxValueX,
					intervals:this.settings.intervalsX,
					labeledIntervals:this.settings.labeledIntervalsX},
				{start:this.settings.minValueY,
					end:this.settings.maxValueY,
					intervals:this.settings.intervalsY,
					labeledIntervals:this.settings.labeledIntervalsY},
				this.settings.fonts,
				this.settings.labels);
			this.drawLegend(this.values,this.settings.fonts);
		},
		pieGraph(){
			var padding = [20,40,20,20]
			this.drawTable(padding,this.settings.title,"","",this.settings.fonts,this.settings.colors);
			this.drawPie(padding, this.values,this.settings.fonts);
			this.drawLegend(this.values,this.settings.fonts);
		},
		barGraph(){
			var padding = [100,40,20,60]
			this.drawTable(padding,this.settings.title,this.settings.labelY,this.settings.labelX,this.settings.fonts,this.settings.colors);
			this.drawBar(padding, this.values,this.settings.fonts);
			this.drawScale(padding,
				{start:this.settings.minValueX,
					end:this.settings.maxValueX,
					intervals:this.settings.intervalsX,
					labeledIntervals:this.settings.labeledIntervalsX},
				{start:this.settings.minValueY,
					end:this.settings.maxValueY,
					intervals:this.settings.intervalsY,
					labeledIntervals:this.settings.labeledIntervalsY},
				this.settings.fonts,
				this.settings.labels);
			this.drawLegend(this.values,this.settings.fonts);
		},

		drawTable(padding,title,yTitle,xTitle,fonts,colors){
			var ctx = this.ctx;

			ctx.lineWidth = 2;
			ctx.strokeStyle = colors.table;
			ctx.strokeRect(
				padding[0],
				padding[1],
				this.width - padding[2]-padding[0],
				this.height - padding[3]-padding[1]);

			ctx.strokeStyle = "#000000";

			ctx.font = (fonts.title*this.fontScale)+"px "+this.font;
			ctx.textAlign = "center"
			ctx.textBaseline = "top"
			ctx.fillText(title,this.percentWidth(50),5);

			ctx.font = (fonts.axis*this.fontScale)+"px "+this.font;
			ctx.textAlign = "start"
			ctx.textBaseline = "middle"
			ctx.fillText(yTitle,5,this.percentHeight(50));

			ctx.font = (fonts.axis*this.fontScale)+"px "+this.font;
			ctx.textAlign = "center"
			ctx.textBaseline = "bottom"
			ctx.fillText(xTitle,this.percentWidth(50),this.height-5);
		},
		drawScale(padding,scaleX,scaleY,fonts,values=null){
			var ctx = this.ctx;

			ctx.lineWidth = 2;
			ctx.fillStyle = "#000000";
			ctx.strokeStyle = "#000000";

			for(let x = 0;x<=scaleX.intervals;x++){
				let valueA = this.paddingPercent(padding,[(x/scaleX.intervals)*100,0]);
				let valueB = this.paddingPercent(padding,[(x/scaleX.intervals)*100,0]);

				ctx.beginPath();
				ctx.moveTo(valueA[0], valueA[1]);
				ctx.lineTo(valueB[0], valueB[1]-5);
				ctx.stroke();
				ctx.closePath();
			}

			if(values!=null){
				for(let x = 0;x<=scaleX.labeledIntervals;x++){
					let value = this.paddingPercent(padding,[(x/scaleX.labeledIntervals)*100,0]);

					ctx.font = (fonts.scale*this.fontScale)+"px "+this.font;
					ctx.textAlign = "center"
					ctx.textBaseline = "top"
					ctx.fillText(values[Math.round((x/scaleX.labeledIntervals) * (values.length-1))],value[0],value[1]+5);
				}
			}else{
				for(let x = 0;x<=scaleX.labeledIntervals;x++){
					let value = this.paddingPercent(padding,[(x/scaleX.labeledIntervals)*100,0]);

					ctx.font = (fonts.scale*this.fontScale)+"px "+this.font;
					ctx.textAlign = "center"
					ctx.textBaseline = "top"
					ctx.fillText(Math.round(scaleX.start + (x/scaleX.labeledIntervals) * (scaleX.end-scaleX.start)),value[0],value[1]+5);
				}
			}

			for(let y = 0;y<=scaleY.intervals;y++){
				let valueA = this.paddingPercent(padding,[0,(y/scaleY.intervals)*100]);
				let valueB = this.paddingPercent(padding,[100,(y/scaleY.intervals)*100]);

				ctx.lineWidth = 1;
				ctx.strokeStyle = "#00000022";
				ctx.beginPath();
				ctx.moveTo(valueA[0]+5, valueA[1]);
				ctx.lineTo(valueB[0], valueA[1]);
				ctx.stroke();
				ctx.closePath();

				ctx.lineWidth = 2;
				ctx.strokeStyle = "#000000";
				ctx.beginPath();
				ctx.moveTo(valueA[0], valueA[1]);
				ctx.lineTo(valueA[0]+5, valueA[1]);
				ctx.stroke();
				ctx.closePath();
			}

			for(let y = 0;y<=scaleY.labeledIntervals;y++){
				let value = this.paddingPercent(padding,[0,(y/scaleY.labeledIntervals)*100]);

				ctx.font = (fonts.scale*this.fontScale)+"px "+this.font;
				ctx.textAlign = "right"
				ctx.textBaseline = "middle"
				ctx.fillText(Math.round(scaleY.start + (y/scaleY.labeledIntervals) * (scaleY.end-scaleY.start)),value[0]-10,value[1]);
			}
		},

		drawLine(padding,values,fonts){
			var ctx = this.ctx;

			for(let v = 0;v<values.length;v++){
				let newValues = [];
				for(let i = 0;i<values[v].coords.length;i++){
					let tempCoords = [
						(values[v].coords[i][0]-this.settings.minValueX)/(this.settings.maxValueX-this.settings.minValueX)*100,
						(values[v].coords[i][1]-this.settings.minValueY)/(this.settings.maxValueY-this.settings.minValueY)*100]
					newValues.push(this.paddingPercent(padding,tempCoords))
				}

				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.strokeStyle = values[v].color;
				ctx.moveTo(newValues[0][0], newValues[0][1]);
				for(let i = 1;i<newValues.length;i++){
					ctx.lineTo(newValues[i][0], newValues[i][1]);
				}
				ctx.stroke();
				ctx.closePath();

				ctx.lineWidth = 2;
				for(let i = 0;i<newValues.length;i++){
					ctx.beginPath();
					ctx.arc(newValues[i][0], newValues[i][1], 2, 0, 2 * Math.PI);
					ctx.stroke();
				}
			}
		},
		drawPie(padding,values,fonts){
			const c = 2 * Math.PI;
			const margin = 20;
			var ctx = this.ctx;

			let center = this.paddingPercent(padding,[50,50]);
			let w = this.width-padding[0]-padding[2];
			let h = this.height-padding[1]-padding[3];

			let size = w>h?h:w;
			size=size/2-margin;

			let total = 0;
			for (var i = 0; i < values.length; i++) {
				total += values[i].coords[0][1];
			}

			let count = 0;
			for(let i = 0;i<values.length;i++){
				let moveAmount = values[i].coords[0][1]/total*c;
				ctx.fillStyle = values[i].color;
				ctx.beginPath();
				ctx.moveTo(center[0],center[1]);
				ctx.arc(center[0], center[1], size, count, count + moveAmount);
				ctx.fill();
				count+=moveAmount;
			}

			count = 0;
			ctx.lineWidth = 2;
			for(let i = 0;i<values.length;i++){
				let moveAmount = values[i].coords[0][1]/total*c;
				ctx.strokeStyle = "#000000";
				ctx.fillStyle = "#000000";
				ctx.beginPath();
				ctx.moveTo(center[0],center[1]);
				ctx.arc(center[0], center[1], size, count, count + moveAmount);
				ctx.stroke();
				count+=moveAmount;

				let radians = ((count - moveAmount) + count)/2;
				let dist = size/2;

				if(moveAmount*dist<(fonts.value*this.fontScale)*2){
					dist = size+(fonts.value*this.fontScale);
				}

				ctx.font = (fonts.value*this.fontScale)+"px "+this.font;
				ctx.textAlign = "center"
				ctx.textBaseline = "middle"
				ctx.fillText(values[i].coords[0][1],center[0]+Math.cos(radians)*dist,center[1]+Math.sin(radians)*dist);
			}
		},
		drawBar(padding,values,fonts){
			var ctx = this.ctx;
			var margin = this.percentWidth(1);
			let w = ((this.width-padding[0]-padding[2])/values[0].coords.length)-margin;

			for(let i = 0;i<values[0].coords.length;i++){
				for(let j = 0;j<values.length;j++){
					let value = [(i)/(values[j].coords.length)*100,(values[j].coords[i][1]-this.settings.minValueY)/(this.settings.maxValueY-this.settings.minValueY)*100];
					let newValue = this.paddingPercent(padding,value);

					ctx.fillStyle = values[j].color;
					ctx.beginPath();
					ctx.rect(newValue[0]+margin/2+(j/values.length)*w, this.height-padding[3],(1/values.length)*w,newValue[1]-(this.height-padding[3]))
					ctx.fill();
				}
			}

			ctx.lineWidth = 2;
			for(let i = 0;i<values[0].coords.length;i++){
				for(let j = 0;j<values.length;j++){
					let value = [(i)/(values[j].coords.length)*100,(values[j].coords[i][1]-this.settings.minValueY)/(this.settings.maxValueY-this.settings.minValueY)*100];
					let newValue = this.paddingPercent(padding,value);

					ctx.strokeStyle = "#000000";
					ctx.beginPath();
					ctx.rect(newValue[0]+margin/2+(j/values.length)*w, this.height-padding[3],(1/values.length)*w,newValue[1]-(this.height-padding[3]))
					ctx.stroke();

					let textYPos = ((this.height-padding[3])+(newValue[1]))/2;
					if(textYPos > (this.height-padding[3])-(fonts.value*this.fontScale)){
						textYPos = newValue[1]-(fonts.value*this.fontScale);
					}

					ctx.fillStyle = "#000000";
					ctx.font = (fonts.value*this.fontScale)+"px "+this.font;
					ctx.textAlign = "center"
					ctx.textBaseline = "middle"
					ctx.fillText(values[j].coords[i][1], newValue[0]+((j/values.length)*w)+margin/2+((1/values.length)*w)/2, textYPos);
				}
			}
		},
		drawStack(padding,values,fonts){
			var ctx = this.ctx;

			var previousValues = [];
			var stackValues = [];
			for(let i = 0;i<values[0].coords.length;i++){
				stackValues.push(0);
				previousValues.push(this.height-padding[3]);
			}

			for(let v = 0;v<values.length;v++){
				let newValues = [];
				for(let i = 0;i<values[v].coords.length;i++){

					stackValues[i]+=values[v].coords[i][1];

					let tempCoords = [
						(values[v].coords[i][0]-this.settings.minValueX)/(this.settings.maxValueX-this.settings.minValueX)*100,
						(stackValues[i]-this.settings.minValueY)/(this.settings.maxValueY-this.settings.minValueY)*100]
					newValues.push(this.paddingPercent(padding,tempCoords))
				}

				ctx.beginPath();
				ctx.lineWidth = 1;
				ctx.fillStyle = values[v].color;
				ctx.moveTo(newValues[0][0], newValues[0][1]);
				for(let i = 0;i<previousValues.length;i++){
					ctx.lineTo(newValues[i][0], previousValues[i]);
				}
				for(let i = newValues.length-1;i>0;i--){
					ctx.lineTo(newValues[i][0], newValues[i][1]);
					previousValues[i]=newValues[i][1]
				}
				ctx.fill();
				ctx.closePath();
			}
		},

		paddingPercent(padding,value){
			let x = padding[0];
			let y = padding[1];
			let w = this.width-padding[0]-padding[2];
			let h = this.height-padding[1]-padding[3];
			return([x+w*(value[0]/100),h+y-h*(value[1]/100)])
		},
		percentWidth(w){
			return(w/100*this.width);
		},
		percentHeight(h){
			return(h/100*this.height);
		},

		toggleLegend(){
			var el = this.ctx_legend.canvas;

			if (el.style.display === "none") {
				el.style.display = "block";
				document.cookie=this.id+"_legend"+"=false;";
			} else {
				el.style.display = "none";
				document.cookie=this.id+"_legend"+"=true;";
			}
		},
		loadToggleLegends(){
			var el = this.ctx_legend.canvas;

			if(api.getCookie(this.id+'_legend')=='true'){
				el.style.display = "none";
			}else{
				el.style.display = "block";
			}
		},
		drawLegend(values,fonts){
			const margin = 10;
			const size = 20;
			var ctx = this.ctx_legend;

			ctx.canvas.height = margin+(margin+size)*values.length;

			ctx.fillStyle = '#ffffff';
			ctx.fillRect(0,0,ctx.canvas.width, ctx.canvas.height);

			ctx.lineWidth = 1;
			for(let i = 0;i<values.length;i++){
				ctx.fillStyle = values[i].color;
				ctx.fillRect(margin,margin+(margin+size)*i,size, size);
				ctx.strokeStyle = '#000000';
				ctx.strokeRect(margin,margin+(margin+size)*i,size, size);

				ctx.fillStyle = "#000000";
				ctx.font = (fonts.legend*this.fontScale)+"px "+this.font;
				ctx.textAlign = "left"
				ctx.textBaseline = "middle"
				ctx.fillText(values[i].label, size+margin+margin, size/2+margin+(margin+size)*i);
			}
		},
	},
	watch:{
		width(){
			this.setup();
		},
		height(){
			this.setup();
		},
		values(){
			this.setup();
		},
		id(){
			this.setup();
		},
	}
}
</script>

<style scoped>
.scroll{
	overflow-x:auto;
}
button{
	position:absolute;
	top:0px;
	right:0px;
	height:30px;
	margin:2px;
}
.legend{
	position:absolute;
	top:35px;
	right:0px;
	border:1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/layouts/chart.vue